import { createContext } from "react";

export const DEFAULT_LINK_TEXT = "View Rates";

export const ThemeContext = createContext({
	linkText: DEFAULT_LINK_TEXT,
	hasTrustPilotWidget: true,
});
